<template>
  <div>
    <router-link class="f messages el-badge" to="">
      <div id="nmBtn" @click="shrink" style="color: black ">
        <span class="icon font_family icon-news" style="font-size: 20px;margin-right: 5px"></span>
        消息
        <sup v-if="messageCount > 0" class="el-badge__content el-badge__content&#45;&#45;undefined is-fixed"
             style="top: 17px">{{ messageCount }} </sup>
      </div>
    </router-link>

    <el-popover
      v-draw
      placement="right-start"
      width="400"
      trigger="manual"
      id="nmPopover"
      style="margin-top: 15px"
      v-model="popoverShow">
      <el-row style="padding-top: 10px; font-weight: bold;">
        <el-col :span="12" style="color: #909399">
          站内消息通知
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button @click="toUserMessageIndex" type="text" style="padding: 0px">消息中心 <i class="el-icon-arrow-right"></i></el-button>
        </el-col>
        <el-divider style="margin: 0px !important;"></el-divider>
        <el-table
          :show-header="false"
          :data="messageList"
          empty-text="暂无新消息"
          style="width: 100%;margin-top: -17px">
          <el-table-column>
            <template slot-scope="scope">
              <div style="cursor: pointer;" @click="viewMessage(scope.row.id)">
                <p style="color: #606266;">{{scope.row.theme}}</p>
                <el-tooltip :content="scope.row.content" placement="left">
                  <el-button type="text" style="text-align: left">
                    <p style="color: #606266;" class="one" >{{scope.row.content}}</p>
                  </el-button>
                </el-tooltip>
                <p style="color: rgb(192, 196, 204);">{{scope.row.createDate}}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 15px" v-if="messageCount > maxShowNum">
          <el-button @click="toUserMessageIndex" type="text" style="padding: 0px">查看更多 <i class="el-icon-arrow-right"></i></el-button>
        </div>
      </el-row>
    </el-popover>
  </div>
</template>

<script>

import API from '@/api/security/target/api_meeting_message';
import {bus} from '../../bus.js';

export default {
  name: "NavMessage",
  data() {
    return {
      maxShowNum: 5, // 最大展示数
      messageCount: 0,
      popoverShow: false,
      loading: false,
      messageList: []
    }
  },
  methods: {
    shrink() {
      this.popoverShow = !this.popoverShow;
    },
    viewMessage(id){
      this.$router.push({
        path: '/messageList?clearTabNav=true&id=' + id
      });
      bus.$emit('viewMessage', {
        id: id
      })
      this.popoverShow = false;
    },
    toUserMessageIndex(){
      this.$router.push({
        path: '/messageList?clearTabNav=true'
      });
      this.popoverShow = false;
    },
    refresh() {
      let params = {
        page: 1,
        limit: this.maxShowNum,
        isSee: '1'
      }
      this.loading = true;
      API.listByUser(params).then((res) => {
        this.loading = false;
        if (res && res.page && res.page.records) {
          this.messageCount = res.page.total;
          this.messageList = res.page.records;
        }
      });
    }
  },
  created() {
    bus.$on('refreshmsgcount', () => {
      this.refresh();
    });
    document.addEventListener("click",e=>{
      let box = document.getElementById("nmPopover");
      let nmBtn = document.getElementById("nmBtn");
      if (box != null && box != undefined && nmBtn != null  && nmBtn != undefined) {
        if(!box.contains(e.target) && !nmBtn.contains(e.target)){
          this.popoverShow =  false;
        }
      }
    });
  },
  mounted() {
     this.refresh();
  }
}
</script>

<style scoped>

.df, .flexdc {
  display: flex;
  overflow: hidden;
}

.list_round {
  width: 6px;
  height: 6px;
  position: relative;
  top: 4px;
  left: 7px;
  margin-right: 17px;
}

.success_color {
  color: #00bd16;
}

.load_fail_btn {
  background-color: #ffffff;
  line-height: 14px;
  font-size: 14px;
  display: inline-block;
  margin-left: 13px;
  padding: 5px 8px;
  color: #5b6be7;
  border-radius: 20px;
}

.download-notify .hiddenBtn {
  position: absolute;
  /*top: 22px;*/
  /*right: 40px;*/
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  z-index: 10000000000000000 !important;
}


.download-notify .hiddenBtn {
  position: absolute;
  top: 22px;
  right: 40px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.download-notify {
  z-index: 100000;
}

#tasksDiv {
  overflow-y: auto;
  height: 330px;
  overflow-x: hidden;
}


::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}


::-webkit-scrollbar-thumb {
  background-color: #93c7f5;
  border-radius: 9px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-track-piece {
  background: linear-gradient(90deg, #d8d9de, #e6e8ec);
  background: -webkit-linear-gradient(90deg, #d8d9de, #e6e8ec);
  border-radius: 9px;
}

/* nav style*/
.messages {
  margin-right: 20px;
  color: #fff;
  /*color: black;*/
  background-color: #d6e6ff;
}

.messages i {
  font-size: 20px;
  margin-right: 6px;
}

.hiddenBtn {
  position: absolute;
  top: 8px;
  right: 40px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.el-notification__closeBtn {
  position: absolute;
  top: 8px;
  right: 15px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.df {
  display: flex;
  overflow: hidden;
}

.el-message-box {
  z-index: 1000000000000000000 !important;
}

.one{
  width: 350px;
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}


</style>



// WEBPACK FOOTER //
// src/components/message/NavMessage.vue